import { FeatureFlagName } from "constants/featureFlags";
import { FeatureFlagsContext } from "contexts/FeatureFlagsContext";
import { useAuth } from "hooks/useAuth";
import { useContext, useMemo } from "react";
import {
    FeatureFlagUser,
    canViewFeature,
    canViewFeatureFromData
} from "utils/featureFlagsEvaluator";

export function useFeatureFlags() {
    const { me, isLoggedIn } = useAuth();
    const { flags, loading, error, isFromHasura, refetch } =
        useContext(FeatureFlagsContext);

    const featureFlagUser: FeatureFlagUser | null = useMemo(() => {
        if (!isLoggedIn || !me) {
            return null; // guest로 처리됨
        }

        return {
            id: me.id,
            role: "user" as const
        };
    }, [me, isLoggedIn]);

    const isFeatureEnabled = useMemo(
        () => (featureName: FeatureFlagName) => {
            const flagData = flags.get(featureName);

            if (flagData) {
                return canViewFeatureFromData(flagData, featureFlagUser);
            }

            // Only use Hasura data - no fallback to local constants
            // Return false if no Hasura data is available for this flag
            return false;
        },
        [flags, featureFlagUser]
    );

    return {
        isFeatureEnabled,
        user: featureFlagUser,
        loading,
        error,
        isFromHasura,
        refetch
    };
}
